// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dp[data-v-afa94cb8]{color:#00475a;font-weight:bolder}.theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr>th[data-v-afa94cb8]{color:#fff;font-size:16px}.mtitle[data-v-afa94cb8]{color:#00475a;margin-bottom:5px;margin-top:20px}.mtitle[data-v-afa94cb8],.value[data-v-afa94cb8]{font-size:16px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
